
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RuleTabTrigger from '@components/settings/rule/RuleTabTrigger.vue'
import RuleTabAction from '@components/settings/rule/RuleTabAction.vue'
import { RuleV2Mutation } from '@clients/myTrips';

export type Tab = 'trigger' | 'action';

@Component({
  name: 'RuleTabs',
  components: {
    RuleTabTrigger,
    RuleTabAction
  }
})
export default class RuleTabs extends Vue {
  @Prop({ required: true })
  private value: RuleV2Mutation;

  @Prop({ default: false })
  private loading: boolean;

  private activeTab: Tab = 'trigger';

  private clickTab(tab: Tab) {
    this.activeTab = tab;
  }
}
